import { render, staticRenderFns } from "./tool-category-edit.vue?vue&type=template&id=61eb3e70&scoped=true&"
import script from "./tool-category-edit.vue?vue&type=script&lang=js&"
export * from "./tool-category-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61eb3e70",
  null
  
)

export default component.exports